<div class="row mb-3">
    <div class="col-md-6">
        <div class="row">
            <div class="col-md-6"><label>Vehicle Insurance (exc IPT):</label></div>
            <div class="col-md-6">
                <div class="input-group">
                    <div class="input-group-prepend">
                        <span class="input-group-text dark-green-bg text-white">&pound;</span>
                    </div>
                    <input type="text" name="vehicle_insurance_exc_ipt" [value]="(premium?gross_premium - (premium.ipt):0) | number:'1.2-2'" class="form-control form-control-sm" readonly>
                </div>
            </div>
        </div>
        <div class="row mt-3">
            <div class="col-md-6"><label>Vehicle IPT:</label></div>
            <div class="col-md-6">
                <div class="input-group">
                    <div class="input-group-prepend">
                        <span class="input-group-text dark-green-bg text-white">&pound;</span>
                    </div>
                    <input type="text" name="vehicle_ipt" [value]="premium?.ipt | number:'1.2-2'" class="form-control form-control-sm" readonly>
                </div>
            </div>
        </div>
        <div class="row mt-3">
            <div class="col-md-6"><label>Total Premium inc IPT:</label></div>
            <div class="col-md-6">
                <div class="input-group">
                    <div class="input-group-prepend">
                        <span class="input-group-text dark-green-bg text-white">&pound;</span>
                    </div>
                    <input type="text" name="gross" [value]="total_prem_inc_ipt | number:'1.2-2'" class="form-control form-control-sm" readonly>
                </div>
            </div>
        </div>
        <div class="row mt-3">
            <div class="col-md-6"><label>Peliwica Fee:</label></div>
            <div class="col-md-6">
                <div class="input-group">
                    <div class="input-group-prepend">
                        <span class="input-group-text dark-green-bg text-white">&pound;</span>
                    </div>
                    <input type="text" name="peliwica_fee" [value]="peliwica_fee | number:'1.2-2'" class="form-control form-control-sm" readonly>
                </div>
            </div>
        </div>
        <div class="row mt-3" *ngIf="quote && quote.is_send_email == 1">
            <div class="col-md-6"><label>Broker Fee:</label></div>
            <div class="col-md-6">
                <div class="input-group">
                    <div class="input-group-prepend">
                        <span class="input-group-text dark-green-bg text-white">&pound;</span>
                    </div>
                    <input type="text" name="broker_admin_fee" [value]="broker_admin_fee | number:'1.2-2'" class="form-control form-control-sm" readonly>
                </div>
            </div>
        </div>
        <div class="row mt-3">
            <div class="col-md-6"><label>Total Payable (inc IPT & Fee):</label></div>
            <div class="col-md-6">
                <div class="input-group">
                    <div class="input-group-prepend">
                        <span class="input-group-text dark-green-bg text-white">&pound;</span>
                    </div>
                    <input type="text" name="total_amount" [value]="total_amount | number:'1.2-2'" class="form-control form-control-sm" readonly>
                </div>
            </div>
        </div>
    </div>
</div>
